import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { APIError } from '@virtual-care/client';

export default function JoinError() {
  const error = useRouteError();
  const { t } = useTranslation();

  const { titleKey, descriptionKey } = mapError(error);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-sm">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">{t(titleKey)}</h1>
        <p className="text-gray-600">{t(descriptionKey)}</p>
      </div>
    </div>
  );
}

function mapError(error: unknown): {
  titleKey: string;
  descriptionKey: string;
} {
  const code = extractErrorCode(error);
  switch (code) {
    case 'meetings/guest-too-early':
      return {
        titleKey: 'appointments.detail.guestError.tooEarly',
        descriptionKey: 'appointments.detail.guestError.tooEarlyDescription',
      };
    case 'meetings/guest-too-late':
    case 'meetings/guest-ended':
      return {
        titleKey: 'appointments.detail.guestError.ended',
        descriptionKey: 'appointments.detail.guestError.endedDescription',
      };
    case 'meetings/guest-not-confirmed':
    case 'meetings/guest-no-meeting':
    case 'meetings/guest-not-b2b':
      return {
        titleKey: 'appointments.detail.guestError.notAvailable',
        descriptionKey:
          'appointments.detail.guestError.notAvailableDescription',
      };
    default:
      return {
        titleKey: 'appointments.detail.guestError.invalid',
        descriptionKey: 'appointments.detail.guestError.invalidDescription',
      };
  }
}

function extractErrorCode(error: unknown): string | undefined {
  if (error instanceof APIError) {
    const cause = error.data?.cause;
    if (
      typeof cause === 'object' &&
      cause !== null &&
      'code' in cause &&
      typeof cause.code === 'string'
    ) {
      return cause.code;
    }
  }
  if (isRouteErrorResponse(error)) {
    return undefined;
  }
  return undefined;
}
